import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("vendor_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("vendor_token");
      localStorage.removeItem("vendor_user");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const requestOtp = (phone) => api.post("/auth/request-otp", { phone });
export const verifyOtp = (phone, code) =>
  api.post("/auth/verify-otp", { phone, code, role: "vendor" });
export const getMe = () => api.get("/vendor/me");
export const getOrders = (params) => api.get("/vendor/orders", { params });
export const setOrderStatus = (id, body) =>
  api.post(`/vendor/orders/${id}/status`, body);
export const updateStore = (body) => api.patch("/vendor/store", body);
export const getAnalytics = () => api.get("/vendor/analytics");

export const getBankDetails = () => api.get("/vendor/bank-details");
export const saveBankDetails = (body) => api.post("/vendor/bank-details", body);
export const saveDocuments = (body) => api.patch("/vendor/documents", body);
export const getEarningsSummary = () => api.get("/vendor/earnings/summary");
export const getEarningsEntries = () => api.get("/vendor/earnings/entries");
export const getRevenue = () => api.get("/vendor/revenue");
export const getMenu = () => api.get("/vendor/menu");
export const saveMenuItem = (body) => api.post("/vendor/menu", body);
export const deleteMenuItem = (id) => api.delete(`/vendor/menu/${id}`);
export const getRiderLocation = (orderId) => api.get(`/vendor/orders/${orderId}/rider-location`);
export const getOutlet = () => api.get("/vendor/outlet");
export const saveOutletAddress = (body) => api.put("/vendor/outlet/address", body);
export const getBusinessHours = () => api.get("/vendor/business-hours");
export const saveBusinessHours = (body) => api.put("/vendor/business-hours", body);

// ---- Our own dashboard backend (offers, ads, weekly report) ----
export const localApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
localApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("vendor_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const listOffers = () => localApi.get("/offers");
export const saveOffer = (b) => localApi.post("/offers", b);
export const removeOffer = (id) => localApi.delete(`/offers/${id}`);
export const listAds = () => localApi.get("/ads");
export const saveAd = (b) => localApi.post("/ads", b);
export const removeAd = (id) => localApi.delete(`/ads/${id}`);
export const getReportSub = () => localApi.get("/reports/me");
export const subscribeReport = (b) => localApi.post("/reports/subscribe", b);
export const sendReportNow = () => localApi.post("/reports/send-now");
export const fareQuote = (b) => localApi.post("/fare/quote", b);
export const getMenuMeta = () => localApi.get("/menu-meta");
export const saveMenuMeta = (b) => localApi.post("/menu-meta", b);
export const listHolidays = () => localApi.get("/holidays");
export const addHoliday = (b) => localApi.post("/holidays", b);
export const removeHoliday = (id) => localApi.delete(`/holidays/${id}`);



export const errMsg = (e) =>
  e?.response?.data?.detail ||
  e?.response?.data?.message ||
  e?.message ||
  "Something went wrong";
